import React, { useEffect, useState } from 'react';
import Box from 'ui-box';

import {
  Container,
  Grid,
  Heading,
  majorScale,
  PageContainer,
  Card,
  PageHeader,
  useToast,
  Spinner,
} from '../../npaper';
import { IDashboard, useStores } from '../../stores';

import { GoalCard } from './GoalCard';
import { KPICard } from './KPICard';
import { LeaderBoard } from './LeaderBoard';

export const Dashboard = () => {
  const { authStore, organisationStore } = useStores();
  const toaster = useToast();

  const [dashboard, setDashboard] = useState<IDashboard | false>();

  useEffect(() => {
    if (!authStore.currentOrganisation) return;
    if (dashboard || dashboard === false) return;

    let isSub = true;
    organisationStore
      .getDashboard(authStore.currentOrganisation)
      .then((dashboard) => isSub && setDashboard(dashboard))
      .catch((err) => {
        setDashboard(false);
        toaster.showDefaultError(err);
      });

    return () => {
      isSub = false;
    };
  }, [authStore.currentOrganisation, dashboard, organisationStore, toaster]);

  return (
    <PageContainer paddingBottom={majorScale(4)}>
      <Container>
        <PageHeader
          title={
            <Heading size={700}>
              {authStore.currentOrganisation
                ? authStore.currentOrganisation.name
                : ''}
            </Heading>
          }
        />
      </Container>
      <Container marginTop={majorScale(4)} paddingBottom={majorScale(8)}>
        {dashboard === undefined && <Spinner />}
        {dashboard === false && <p>Could not fetch dashboard.</p>}
        {dashboard && (
          <Grid>
            {dashboard.map((item, i) =>
              item.type === 'goal' ? (
                <GoalCard
                  key={i}
                  flexGrow={1}
                  className="col-span-4"
                  description={item.title}
                  value={item.value.current}
                  formatting={{ format: 'percent' }}
                  goal={item.value.goal}
                />
              ) : item.type === 'graph' ? (
                <KPICard
                  key={i}
                  className="col-span-4"
                  value={Math.random() * 1000000 + 4500000}
                  description={item.title}
                  currency="DKK"
                  data={{
                    id: item.key,
                    data: item.value.map((v, i) => ({
                      x: v.date,
                      y: v.value,
                    })),
                  }}
                />
              ) : item.type === 'leaderboard' ? (
                <Card
                  key={i}
                  className="col-span-12"
                  marginTop={majorScale(2)}
                  padding={majorScale(4)}
                >
                  <LeaderBoard leaderboard={item} />
                </Card>
              ) : (
                <Box key={i} className="col-span-4">
                  Unkown dashboard item
                </Box>
              )
            )}
            {/*
          <SalesGoalCard
            description="Salgsmål"
            marginTop={majorScale(2)}
            className="col-span-8"
            data={new Array(12).fill(0).map((_, i) => {
              const goal = 150000;
              const value = (i / 12 + 1) * (Math.random() + 0.7) * 100000;
              return {
                date: `2021/${i + 1}/01`,
                revenue: value,
                revenueColor: defaultFills.success[500],
                remaining: Math.max(goal - value, 0),
                remainingColor: defaultFills.muted,
                goal: goal,
              };
            })}
            keys={['revenue', 'goal']}
            indexBy="date"
            value={150000 * 12}
            formatting={{
              currency: 'DKK',
              format: 'currency',
            }}
          />
          <KPICard
            className="col-span-4"
            value={(Math.random() / 10) * 100 + 25}
            description="Nye kunder"
            options={{
              style: 'decimal',
            }}
            data={{
              id: 'revenue',
              data: new Array(12).fill(0).map((_, i) => ({
                x: `2021/${i + 1}/01`,
                y: (i / 24 + 1) * (Math.random() + 0.2) * 10,
              })),
            }}
          />
          */}
          </Grid>
        )}
      </Container>
    </PageContainer>
  );
};
